import React from 'react';
import styled from 'styled-components';
import VehicleStateImg from './vehicle-state-img';
import { VehicleModelProps } from './cargo-model';
import RoofImg from '../../assets/images/cargo-model/roof.png';

class VehicleRoof extends React.Component<VehicleModelProps, any> {
  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler('roof');
  };

  render() {
    const { className, vehicleState } = this.props;

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState.roof}`}
        src={RoofImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleRoof = styled(VehicleRoof)`
  position: relative;
  width: 10.5em;
  top: -3.4em;
`;

export default StyledVehicleRoof;
